import commonsDev from './commonsDev'
import commonsProd from './commonsProd'
let system = commonsProd
export default system
